import { useEffect, useMemo, useRef, useState } from "react";
import { MeetingProvider, createCameraVideoTrack  } from "@videosdk.live/react-sdk";

import { authToken, createMeeting } from "../page_components/videocall/API";

// CSS
import '../styles/videoconference.css'

// VIDEOCALL
import JoinScreen from "../page_components/videocall/JoinScreen";
import MeetingView from "../page_components/videocall/MeetingView";
import ResolutionListener from "../page_components/videocall_new/ResolutionListener";





// AMPLIFY
import { generateClient } from 'aws-amplify/api';
import useModelData from "../hooks/useModelData";

// SUBSCRIPTION FOR PINGING WEBSOCKET AND REAL-TIME UPDATES
import {
    onCreateTransaction,
    onUpdateTransaction,
    onDeleteTransaction,
    onUpdateWitnessTransaction,

  } from "../graphql/subscriptions";

// QUERIES IS FOR READ
import { listTransactions,listWitnessTransaction } from "../graphql/queries";


// MUTATIONS IS FOR CREATE , UPDATE AND DELETE
import {
    createTransaction,
    updateTransaction,
    deleteTransaction,
    updateWitnessTransaction
  } from "../graphql/mutations";



// SMS AND EMAIL
import useSendSMS from "../hooks/useSendSMS";
import useSendEmail from '../hooks/useSendEmail';
import useUpdate from "../hooks/useUpdate";


import { useParams } from "react-router-dom";
import { useAuth } from '../contexts/AuthContext';

 
 
const VideoCallNewest = ({selectedItem}) => {

    const { user } = useAuth();
    const lawyerId = user.user_id;


    // FOR VIDEOQUALITY
    const getTrack = async () => {
        const track = await createCameraVideoTrack({
          optimizationMode: "motion",
          encoderConfig: "h90p_w160p",
          facingMode: "environment",
          multiStream:true 
        });
        setCustomTrack(track);
      };
    
      let [customTrack, setCustomTrack] = useState();
    
      useEffect(() => {
        getTrack();
      }, []);


    const { updateData, isLoading, errorMessage, successMessage } = useUpdate("patch");
    const { sendSMS, response, error }                            = useSendSMS();
    const { sendEmail, response:emailResponse, error:emailError } = useSendEmail();
    const [meetingId, setMeetingId] = useState(null);



     // UPDATE WITNESSES
          const { updateItem:updateItemWitnessTransaction, checkItemExists } = useModelData({
            model: "WitnessTransaction",
            queries: {
              list: listWitnessTransaction, // Assuming you have a query for listing
              update: updateWitnessTransaction,
            },
            subscriptions: {
              onUpdate: onUpdateWitnessTransaction,
            }
          });
        
        
        
        
          const triggerBulkUpdateByTransactionId = async () => {

            console.log("triggered updated",selectedItem.transaction_id);
            try {
              // Step 1: Query all WitnessTransaction items with this transaction_id
              const result = await client.graphql({
                query: listWitnessTransaction,
                variables: {
                  filter: {
                    transaction_id: { eq: selectedItem.transaction_id }
                  }
                }
              });
          
              const key = Object.keys(result.data)[0];
              const items = result.data[key]?.items || [];
          
          
              // Step 2: Loop through each item and update it (this can be a no-op or real update)
              await Promise.all(items.map(async (item) => {
                await updateItemWitnessTransaction({
                  id: item.id,
                  transaction_status:"FOR OATH",
                  updated_by:lawyerId
                });
              }));
          
              console.log(`Triggered update for ${items.length} items with transaction_id: ${selectedItem.transaction_id}`);
            } catch (error) {
              console.error("Failed to trigger bulk update:", error);
            }
        };




    const fetchWitnesses = async (transaction_id)=>{

              const filter = {
                transaction_id: { eq: transaction_id },
                };
      
                const variables = { filter };
      
              try {
                // Step 1: Check if the user already exists
                const checkResponse = await client.graphql({
                  query: listWitnessTransaction,
                  variables: variables,
                  
                });
      
                console.log("checkResponse",checkResponse);
          
                // if (checkResponse.data.listTransactionLawyers.items.length > 0) {
                //   console.log("User status already exists, updating...");
          
                //   // Step 2: If the user exists, get the ID and update the user status
                //   const existingStatus = checkResponse.data.listTransactionLawyers.items[0]; // Take the first item (you may need to adjust if there are multiple)
          
                
                  return checkResponse;
                // }
      
              } catch (error) {
                console.error("Error handling user status:", error);
              }
    }


    function detectInputType(input) {
      // Regex for a basic email format
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      // Regex for Philippine phone number format (11 digits starting with 09)
      const phoneRegexPH = /^09\d{9}$/;
    
      if (emailRegex.test(input)) {
        return 'email';
      }
      if (phoneRegexPH.test(input)) {
        return 'phone';
      }
      return 'unknown';
    }


    const email_numbers = ['09217390169', 'test@gmail.com', 'test2@gmail.com', 'sadreality'];


 
    const getMeetingAndToken = async (id) => {
        const meetingId = id == null ? await createMeeting({ token: authToken }) : id;
        const rand = generateRandomString();


        setMeetingId(meetingId);
        updateMeetingId(meetingId,rand?.toUpperCase());

        triggerBulkUpdateByTransactionId(); 



       const result = await fetchWitnesses(selectedItem.transaction_id);
       const emails_numbers = result.data.listWitnessTransactions.items;

       console.log("itemssss",emails_numbers);

 


      // UPDATE MEETING ID AND PW IN DB
      const formData = new FormData();
      formData.append('meeting_id', meetingId);
      formData.append('meeting_pass', rand.toUpperCase());
      formData.append('transaction_id', selectedItem.transaction_id);

      
      try {
        const url = `${process.env.REACT_APP_API_URL}/transactions/update_meeting/`;
        await updateData(url, formData, (responseData) => {
      
          if (responseData) {
            if(responseData.status==="success"){

              console.log("METTINGGGG",responseData.status);

                   for (const item of emails_numbers) {
                    const type = detectInputType(item.contact_info);
                    if (type === 'email') {
                       //sendEmail('Meeting Created',`Your meeting ID: ${meetingId} <br/>  password is: ${rand.toUpperCase()}`, item.contact_info)
                    } else if (type === 'phone') {
                       //sendSMS(`Your meeting ID: ${meetingId}  password is: ${rand.toUpperCase()}`, item.contact_info);
                    } else {
                      console.log(`${item.contact_info} is not valid`);
                    }
                }
            }
          }
        });

      } catch (error) {
        console.error('Update failed:', error);
      }
 
  
    };


  



    //This will set Meeting Id to null when meeting is left or ended
    const onMeetingLeave = () => {
        setMeetingId(null);
    };


    useEffect(() => {
        if (meetingId !== null) {
          console.log('Updated meetingId in parent:', meetingId);
        }
      }, [meetingId]);




    const client = generateClient();



    const generateRandomString = (length = 4) => {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        const charactersLength = characters.length;
        
        for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    };

      
      // Fetch the initial transactions
      useEffect(() => {
     
    
        // Subscribe to real-time updates when a transaction is updated
        const updateSub = client
          .graphql({ query: onUpdateTransaction })
          .subscribe({
            next: ({ data }) => {
              const updatedTransaction = data.onUpdateTransaction;

    
            },
            error: (error) => {
              console.warn("Subscription error:", error);
            },
          });
  
    
        // Cleanup subscriptions on component unmount
        return () => {
          updateSub.unsubscribe();
        };
      }, []);


      const updateMeetingId = async (id,pass) =>{
 
            const updateVariabled = {
                input: {
                    id:selectedItem.id,
                    meeting_id: id,
                    meeting_pass: pass,
                    negotiation_status:"SUCCESS"
                }
            };
    
            // Step 3: Call the update mutation
            const updateResponse = await client.graphql({
                query: updateTransaction,
                variables: updateVariabled,
            });




          
        }


        
           
    


    return authToken && meetingId ? (
        customTrack && (
            <>
            <MeetingProvider
                config={{
                    
                    meetingId,
                    micEnabled   : true,
                    webcamEnabled: true,
                    // participantId: "xyz",
                    permissions: {
                        askToJoin              : false,
                        toggleParticipantWebcam: false,
                        removeParticipant      : true,
                        endMeeting             : true,
                    },
                    // maxResolution: "hd",
                    // defaultCamera:"front",
                    // multiStream:true
                    customCameraVideoTrack: customTrack,
                }}
                token={authToken}>

{/* sendPushNotification={sendPushNotification} */}
                    
                <MeetingView  meetingId={meetingId} onMeetingLeave={onMeetingLeave}  selectedItem={selectedItem}  />
            </MeetingProvider>
        {/* <JoinScreen getMeetingAndToken={getMeetingAndToken} meetingId={meetingId}/> */}
           
            </>
        )
    ) : (
        <JoinScreen getMeetingAndToken={getMeetingAndToken} meetingId={meetingId}/>
    )
    
    ;
}

export default VideoCallNewest;